import { useTranslation } from 'react-i18next';

export function ProgressBar({ progress, min = 0, max = 100 }) {
  const { t } = useTranslation();

  return (
    <div
      className="relative h-[5px] w-full rounded-[5px] bg-primary-100 overflow-hidden"
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-label={t('progress', { progress })}
    >
      <div
        className="h-full rounded-[0_5px_5px_0] bg-primary-active"
        style={{ width: `${(progress / max) * 100}%` }}
      />
    </div>
  );
}
